import _extends from "@swc/helpers/src/_extends.mjs";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { BiEventType, BiDataHook } from '@wix/da-bi/pkg/constants';
import LoadingIndicator from '../../../LoadingIndicator';
import ThreadPagination from '../../_partials/ThreadPagination';
import { MIN_COMMENT_COUNT_TO_SHOW_BOTTOM_POST } from '../../constants';
import ThreadHeader from '../../_partials/ThreadHeader';
import ThreadPostbox from '../../_partials/ThreadPostbox';
import ThreadStack from '../../_partials/ThreadStack';
import DesktopComments728x90 from '@wix/da-ads/pkg/adunits/DesktopComments728x90';
import { useShouldRenderAdArea } from '@wix/da-ads/pkg/useShouldRenderAdArea';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ErrorBoundary from '../../../ErrorBoundary';
import s from './SimpleThread.scss';
const SimpleThread = ({ commentableItemId , commentableTypeId , parentId , parentComment , parentCommentRef , className , postbox , itemCount , maxCommentsShown , statsAndControls , extraInHeader , streamId , allowSelfInit , isFetching , isInfinite , commentComponent , scrollableClassName , commentClassName , commentWrapperClassName , viewRepliesClassName , maxDepthOverride , replyIndentModifier , commentBoxWrapperClassName , threadStackClassName , headerClassName , isSticky , withCommentSuggestions , adSafety , withAd =false  })=>{
    const isMobile = useContext(MobileContext);
    const showAd = useShouldRenderAdArea(adSafety);
    const isTopPostboxVisible = postbox === 'top' || postbox === 'both';
    const isTopmostPostboxVisible = postbox === 'topmost';
    const isBottomPostboxVisible = postbox === 'bottom' || postbox === 'both' && itemCount >= MIN_COMMENT_COUNT_TO_SHOW_BOTTOM_POST;
    const isNotLimitingComments = !maxCommentsShown;
    const postBoxProps = {
        commentableItemId,
        commentableTypeId,
        parentId,
        parentComment,
        isSticky,
        withCommentSuggestions,
        className: commentBoxWrapperClassName
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: className,
        "data-hook": BiDataHook.COMMENTS_THREAD
    }, withAd && showAd && !isMobile && /*#__PURE__*/ React.createElement("div", {
        className: s['ad']
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "DesktopComments728x90"
    }, /*#__PURE__*/ React.createElement(DesktopComments728x90, {
        safety: adSafety
    }))), isTopmostPostboxVisible && /*#__PURE__*/ React.createElement(ThreadPostbox, _extends({}, postBoxProps, {
        position: "topmost"
    })), statsAndControls !== 'off' && /*#__PURE__*/ React.createElement(ThreadHeader, {
        commentableItemId: commentableItemId,
        commentableTypeId: commentableTypeId,
        parentId: parentId,
        withOrder: [
            'on',
            'order'
        ].includes(statsAndControls),
        withTitle: [
            'on',
            'title'
        ].includes(statsAndControls),
        className: classnames(s['header'], headerClassName)
    }, extraInHeader), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['scrollable'], scrollableClassName)
    }, /*#__PURE__*/ React.createElement("div", null, isTopPostboxVisible && /*#__PURE__*/ React.createElement(ThreadPostbox, _extends({}, postBoxProps, {
        position: "top"
    })), isNotLimitingComments && /*#__PURE__*/ React.createElement(ThreadPagination, {
        direction: "prev",
        streamId: streamId,
        biData: {
            evid: BiEventType.LOAD_MORE_COMMENTS_CLICK,
            is_load_previous: 1,
            itemid: commentableItemId,
            typeid: commentableTypeId
        }
    }), /*#__PURE__*/ React.createElement(ThreadStack, {
        className: threadStackClassName,
        commentableItemId: commentableItemId,
        commentableTypeId: commentableTypeId,
        parentId: parentId,
        maxCommentsShown: maxCommentsShown,
        commentComponent: commentComponent,
        parentComment: parentComment,
        parentCommentRef: parentCommentRef,
        allowSelfInit: allowSelfInit,
        maxDepthOverride: maxDepthOverride,
        commentClassName: commentClassName,
        commentWrapperClassName: commentWrapperClassName,
        viewRepliesClassName: viewRepliesClassName,
        replyIndentModifier: replyIndentModifier
    }), isFetching && /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "llama"
    }), isNotLimitingComments && /*#__PURE__*/ React.createElement(ThreadPagination, {
        direction: "next",
        className: s['load-more'],
        isInfinite: isInfinite,
        streamId: streamId,
        biData: {
            evid: BiEventType.LOAD_MORE_COMMENTS_CLICK,
            itemid: commentableItemId,
            typeid: commentableTypeId
        }
    }))), isBottomPostboxVisible && /*#__PURE__*/ React.createElement(ThreadPostbox, _extends({}, postBoxProps, {
        position: "bottom"
    })));
};
SimpleThread.displayName = 'SimpleThread';
export default SimpleThread;
